import React, { useEffect, useState, useRef } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  Stack,
  Typography
} from "@mui/material";
import { MoreVert as MoreIcon, LocationOn as MapMarkerIcon } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { FETCH_PROJECTS_PRODUCTS, SAVE_PROJECTS_PRODUCTS } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { BIGrey, BIRed } from "../../assets/helpers";
import SearchField from "../common/SearchField";
import AddProductModal from "../common/AddProductModal";
import BuildIcon from "@mui/icons-material/Build";
import { useDispatch } from "react-redux";
import { setShowReport } from "../../redux/actions/actions";
import { English } from "../../constant/EnglishFallback";
import Emptydata from "../common/Emptydata";
import InfiniteScroll from "react-infinite-scroll-component";
import Pages from "../../constant/ReportModel";

function ProjectProductSection({ id, scrollId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const {
    TEXT_ADD_PRODUCT = English?.ProjectProductSection?.TEXT_ADD_PRODUCT,
    TEXT_ADD_PRODUCTTO_PROJECT = English?.ProjectProductSection?.TEXT_ADD_PRODUCTTO_PROJECT,
    TEXT_PROJECT_NO_INFORMATION = English?.ProjectProductSection?.TEXT_PROJECT_NO_INFORMATION,
    TEXT_NO_DATA_INFO_SUBTEXT = English?.ProjectProductSection?.TEXT_NO_DATA_INFO_SUBTEXT,
    TEXT_SEARCH_PROJECT_PRODUCT = English?.ProjectProductSection?.TEXT_SEARCH_PROJECT_PRODUCT,
    TEXT_NO_RESULTS_FOUND = English?.ProjectProductSection?.TEXT_NO_RESULTS_FOUND,
    BUTTON_REPORT = English?.ProjectProductSection?.BUTTON_REPORT
  } = multiLanguageData?.ProjectProductSection || {};
  const debounceTimeout = useRef(null);
  const [recordId, setRecordId] = useState(0);
  const [productData, setProductData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchLoader, setShowSearchLaoder] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [product, setProduct] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  useEffect(() => {
    getInitialData();
  }, []);

  const getInitialData = async () => {
    setIsLoading(true);
    await getProductData(searchTerm, 1, "fristTimeApiCall");
    setIsLoading(false);
  };

  const getProductData = async (searchTerm, pageNumber, fristTimeApiCall) => {
    try {
      setAllDataLoaded(true);
      const obj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 20,
        FullSearch: searchTerm ?? "",
        SearchList: [{ projectId: id }],
        userId: Number(currentUserId),
        IncludeRecordNr: true,
        SortList: [{}],
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true
      };
      const res = await Postrequestcall(FETCH_PROJECTS_PRODUCTS, obj, loginData?.accessToken);
      if (res.status === 200) {
        let resData =
          res?.data?.data?.sort((a, b) => b?.productName?.localeCompare(a?.productName)) ?? [];

        // Group the data by manufacturerId or manufacturerName
        const groupedData = resData.reduce((acc, item) => {
          const key =
            item?.manufacturerId === 0 || item?.manufacturerName?.trim() === ""
              ? "Unknown Manufacturer"
              : item?.manufacturerName;

          if (!acc[key]) {
            acc[key] = {
              manufacturerId: item?.manufacturerId,
              manufacturerName:
                item?.manufacturerId === 0 || item?.manufacturerName?.trim() === ""
                  ? "Unknown Manufacturer"
                  : item?.manufacturerName,
              items: []
            };
          }

          acc[key].items.push(item);
          return acc;
        }, {});

        // Convert groupedData to an array of groups
        let groupData = Object.values(groupedData);

        // Separate "Unknown Manufacturer" data to be added at the end
        const unknownData = groupData.find(
          (group) => group?.manufacturerName === "Unknown Manufacturer"
        );

        // If "Unknown Manufacturer" group exists, remove it and add it to the end
        if (unknownData) {
          groupData = groupData.filter(
            (group) => group?.manufacturerName !== "Unknown Manufacturer"
          );
          groupData.push(unknownData); // Add "Unknown Manufacturer" group at the end
        }

        // Set product data
        if (pageNumber > 1) {
          setTimeout(() => {
            setProductData((prevProducts) => [...prevProducts, ...groupData]);
          }, 500);
        } else {
          setProductData(() => groupData);
          // Set hasData for the first time API call
          if (fristTimeApiCall) {
            setHasData(groupData?.length > 0);
          }
        }
      }
    } catch (error) {
      console.log("getProductData-> Error Fetching Poject Product: ", error);
    } finally {
      setShowSearchLaoder(false);
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      name: Pages?.projectProducts?.name,
      AppScreenId: Pages?.projectProducts?.id,
      recordId: product.id ?? 0
    };
    dispatch(setShowReport(reportObj));
  };

  const onAddProductClick = () => {
    setShowAddProductModal(true);
  };

  const onItemClick = (item) => {
    navigate(`/product/${item?.productId}`);
  };

  const onProductClick = (currentTarget, product) => {
    setProduct(product);
    setMoreMenuAnchorEl(currentTarget);
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const saveProduct = async (productId) => {
    try {
      setIsLoading(true);
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            ProductId: productId,
            ProjectId: id,
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1
          }
        ]
      };
      await Postrequestcall(SAVE_PROJECTS_PRODUCTS, obj, loginData?.accessToken);
      await getInitialData();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("saveProduct-> Error Saving Project Product: ", error);
    }
  };

  const NoInformation = () => {
    return (
      <Stack gap={1} sx={{ height: "100%" }}>
        <Button onClick={onAddProductClick} sx={{ alignSelf: "flex-end" }}>
          {TEXT_ADD_PRODUCT}
        </Button>
        <Box className="empty-data-card">
          <Emptydata
            icon={<BuildIcon className="emptydata-icon" />}
            firstText={TEXT_PROJECT_NO_INFORMATION}
            secondText={TEXT_NO_DATA_INFO_SUBTEXT}
          />
        </Box>
      </Stack>
    );
  };

  const renderListing = () => {
    return (
      <Box>
        <Stack gap={1}>
          <SearchField
            placeholder={TEXT_SEARCH_PROJECT_PRODUCT}
            value={searchTerm}
            onChange={(value) => {
              setShowSearchLaoder(true);
              const searchValue = value;
              setSearchTerm(searchValue);
              if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
              }
              debounceTimeout.current = setTimeout(() => {
                getProductData(value, 1);
              }, 1000);
            }}
            onSubmit={() => {
              setShowSearchLaoder(true);
              setShowSearchLaoder(searchTerm);
              getProductData(searchTerm, 1);
            }}
            size={"small"}
          />
          <Button variant="text" sx={{ alignSelf: "flex-end" }} onClick={onAddProductClick}>
            {TEXT_ADD_PRODUCT}
          </Button>
        </Stack>
        <Stack spacing={1}>
          {showSearchLoader ? (
            <Stack style={{ padding: "30px" }}>
              <Loader />
            </Stack>
          ) : productData?.length > 0 ? (
            <>
              <InfiniteScroll
                dataLength={productData?.length}
                next={async () => {
                  increaseOffset((pageNumber) => {
                    getProductData(searchTerm, pageNumber);
                  });
                }}
                hasMore={true}
                loader={
                  !allDataLoaded ? null : (
                    <h4 style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </h4>
                  )
                }
                scrollableTarget={scrollId}>
                <List disablePadding>
                  {productData.map((item) => (
                    <Box key={item?.id}>
                      <ListSubheader
                        key={`subheader-${item?.manufacturerId}`}
                        sx={{ pl: 0.5, cursor: "pointer" }}
                        onClick={() => {
                          item?.manufacturerName !== "Unknown Manufacturer" &&
                            navigate(`/manufacture/${item?.manufacturerId}`);
                        }}>
                        {item?.manufacturerName}
                      </ListSubheader>
                      <Stack spacing={1}>
                        {item?.items?.map((product) => (
                          <Card
                            key={product?.id ?? `${product?.productName}-${Math.random()}`}
                            className="pagelist-content">
                            <ListItem
                              // key={product?.id}
                              style={{ padding: "0px" }}
                              secondaryAction={
                                <IconButton
                                  onClick={(event) => onProductClick(event.currentTarget, product)}>
                                  <MoreIcon />
                                </IconButton>
                              }>
                              <ListItemButton
                                onClick={() => {
                                  onItemClick(product);
                                }}>
                                <ListItemText primary={product?.productName} />
                              </ListItemButton>
                            </ListItem>
                          </Card>
                        ))}
                      </Stack>
                    </Box>
                  ))}
                </List>
                <Menu
                  anchorEl={moreMenuAnchorEl}
                  open={Boolean(moreMenuAnchorEl)}
                  onClose={() => setMoreMenuAnchorEl(null)}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}>
                  <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                    {BUTTON_REPORT}
                  </MenuItem>
                </Menu>
              </InfiniteScroll>
            </>
          ) : (
            <Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              style={{ color: BIGrey, padding: "30px" }}>
              {TEXT_NO_RESULTS_FOUND}
            </Stack>
          )}
        </Stack>
      </Box>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader /> : hasData ? renderListing() : <NoInformation />}
        {showAddProductModal && (
          <AddProductModal
            open={showAddProductModal}
            onClose={() => {
              setShowAddProductModal(false);
            }}
            from={"project"}
            mainId={id}
            saveProduct={saveProduct}
            title={TEXT_ADD_PRODUCTTO_PROJECT}
          />
        )}
      </Card>
    </Box>
  );
}

export default ProjectProductSection;
